import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const BagIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="M12 1c-1.173 0-2.39.378-3.322.965C7.771 2.535 7 3.395 7 4.413V8H2.505A.505.505 0 0 0 2 8.5v12.854a2 2 0 0 0 1.654 1.97c2.447.43 5.895.644 8.342.644 2.448 0 5.897-.215 8.35-.644A2 2 0 0 0 22 21.353V8.5c0-.276-.227-.5-.503-.5L17 7.999V4.463c0-1.032-.761-1.905-1.672-2.486A6.38 6.38 0 0 0 12 1Zm4 7.999V11.5a.5.5 0 0 0 1 0V8.999h4v12.354a1 1 0 0 1-.827.985c-2.378.416-5.767.63-8.177.63-2.41 0-5.796-.213-8.169-.63A1 1 0 0 1 3 21.353V9l4-.001V11.5a.5.5 0 0 0 1 0V8.999h8Zm0-1V4.463c0-.524-.41-1.133-1.21-1.644A5.38 5.38 0 0 0 12 2c-.975 0-2.008.32-2.79.811C8.406 3.318 8 3.915 8 4.413V8h8Z"
    />
  </IconWrapper>
)

export default BagIconMedium
